<template>
  <div>
    <v-main>
      <ClassRecordsContainer />
    </v-main>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from "vue";
import ClassRecordsContainer from '@/container/records/ClassRecordsContainer.vue';

export default defineComponent({
  components: {
    ClassRecordsContainer,
  },
});
</script>
